jQuery(document).ready(function ($) {
    $("#wens-musico-pro-video-block-popup a").magnificPopup({
        type: "iframe",
        closeBtnInside: true,
        mainClass: "mfp-with-zoom mfp-img-mobile wens-musico-pro-video-popup",
        iframe: {
            patterns: {
                youtube: {
                    index: 'youtube.com/',
                    id: 'v=',
                    src: 'https://www.youtube.com/embed/%id%?autoplay=1',
                },
            }
        },
    });
});


